export default __webpack_public_path__ + "static/media/32.eaf7e47b.jpg";